export default __webpack_public_path__ + "static/media/drink3.a8116ebf.jpg";